import { render, staticRenderFns } from "./user_task_item.vue?vue&type=template&id=bdd3000c&scoped=true&"
import script from "./user_task_item.vue?vue&type=script&lang=js&"
export * from "./user_task_item.vue?vue&type=script&lang=js&"
import style0 from "./user_task_item.vue?vue&type=style&index=0&id=bdd3000c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd3000c",
  null
  
)

export default component.exports